module.exports = "/virtual-football-league/img/amblems/right/Germany/Fake_Bayern.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/Germany/Fake_Bayern.png
// module id = 2138
// module chunks = 4